(() => {
  if (customElements.get('klove-fabric-picker')) return;
  class FabricPicker extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.items = [...this.querySelectorAll('[data-fabric-item]')];
      this.toolbar = this.querySelector('[data-fabric-collections]');
      if (!this.items.length || !this.toolbar) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.groups = new Map();
      this.items.forEach(item => {
        const label = item.dataset.fabricLabel || '';
        const match = label.match(/^(BOSCO|PERFECT HARMONY|CLOUD|QUELLE)\s+(\d+)\b/i);
        const family = match ? match[1].toUpperCase() : this.dataset.otherLabel;
        item.dataset.fabricFamily = family;
        const input = item.htmlFor ? this.querySelector(`input[id="${item.htmlFor}"]`) : null;
        item.fabricInput = input;
        if (!this.groups.has(family)) this.groups.set(family, []);
        this.groups.get(family).push(item);
        const code = item.querySelector('[data-fabric-code]');
        if (code && match) {
          code.textContent = match[2];
          // Keep the full label available to the accordion summary and readers.
          if (input) {
            const prefix = document.createElement('span');
            prefix.className = 'visually-hidden'; prefix.textContent = family + ' ';
            code.prepend(prefix);
          }
        }
      });
      this.buttons = [];
      this.toolbar.replaceChildren();
      this.groups.forEach((items, family) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kfp__collection';
        button.dataset.collection = family;
        button.setAttribute('aria-pressed', 'false');
        const name = document.createElement('span'); name.textContent = family;
        const count = document.createElement('span'); count.className = 'kfp__count'; count.textContent = items.length; count.setAttribute('aria-hidden', 'true');
        button.append(name, count);
        button.addEventListener('click', () => this.showFamily(family), {signal});
        this.toolbar.append(button); this.buttons.push(button);
      });
      this.querySelector('[data-fabric-picker-controls]').hidden = false;
      this.classList.add('kfp--ready');
      this.bed = this.closest('bed-configurator');
      this.syncSelection(true);
      if (this.bed) this.bed.addEventListener('change', event => this.syncSelection(event.target === this.bed), {signal});
      // Home selection is confirmed only after its image has successfully loaded.
      this.observer = new MutationObserver(() => this.syncSelection(false));
      this.items.filter(item => !item.fabricInput).forEach(item => this.observer.observe(item, {attributes: true, attributeFilter: ['aria-pressed']}));
    }
    syncSelection(force = false) {
      const selected = this.items.find(item => item.fabricInput ? item.fabricInput.checked : item.getAttribute('aria-pressed') === 'true');
      const changed = selected !== this.selected;
      this.selected = selected;
      const selectionRoot = this.closest('[data-home-fabric-preview]') || this;
      const text = selectionRoot.querySelector('[data-fabric-chosen-name]');
      text.textContent = selected?.dataset.fabricLabel || this.dataset.emptyLabel;
      const thumb = selectionRoot.querySelector('[data-fabric-chosen-image]');
      const source = selected?.querySelector('img');
      thumb.hidden = !source;
      if (source) { thumb.src = source.currentSrc || source.src; thumb.alt = ''; }
      const zoom = selectionRoot.querySelector('[data-fabric-selected-zoom]');
      const original = selected?.querySelector('[data-fabric-preview]');
      const zoomSource = original?.dataset.fabricImage || selected?.dataset.fabricSwatchFull;
      zoom.hidden = !zoomSource;
      if (zoomSource) {
        zoom.href = zoomSource; zoom.dataset.fabricImage = zoomSource;
        zoom.dataset.fabricTitle = selected.dataset.fabricLabel;
        zoom.dataset.fabricDescription = original?.dataset.fabricDescription || '';
        zoom.dataset.fabricCollection = selected.dataset.fabricFamily;
      }
      if (changed || force) this.syncDetail(selected, zoomSource, original);
      this.buttons.forEach(button => button.dataset.containsSelection = String(button.dataset.collection === selected?.dataset.fabricFamily));
      if (!this.family || force || (changed && this.bed)) this.showFamily(selected?.dataset.fabricFamily || this.groups.keys().next().value);
    }
    showFamily(family) {
      if (!this.groups.has(family)) return;
      this.family = family;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.collection === family)));
      this.items.forEach(item => {
        item.hidden = item.dataset.fabricFamily !== family;
        if (item.fabricInput) item.fabricInput.hidden = item.hidden;
      });
      this.querySelector('[data-fabric-family-name]').textContent = family;
      this.querySelector('[data-fabric-color-count]').textContent = this.dataset.countLabel.replace('[count]', this.groups.get(family).length);
    }
    syncDetail(selected, url, original) {
      const panel = this.bed?.querySelector('[data-bed-fabric-detail]');
      if (!panel) return;
      const request = this.detailRequest = (this.detailRequest || 0) + 1;
      panel.hidden = true;
      if (!url || !selected) return;
      const pending = new Image();
      pending.onload = () => {
        if (request !== this.detailRequest || !this.controller) return;
        const img = panel.querySelector('[data-bed-fabric-detail-image]');
        img.src = url; img.alt = selected.dataset.fabricLabel;
        panel.href = url;
        panel.dataset.fabricImage = url;
        panel.dataset.fabricTitle = selected.dataset.fabricLabel;
        panel.dataset.fabricCollection = selected.dataset.fabricFamily;
        panel.dataset.fabricDescription = original?.dataset.fabricDescription || '';
        panel.querySelector('[data-bed-fabric-detail-name]').textContent = selected.dataset.fabricLabel;
        panel.hidden = false;
      };
      pending.onerror = () => { if (request === this.detailRequest) panel.hidden = true; };
      pending.src = url;
    }
    disconnectedCallback() {
      this.detailRequest = (this.detailRequest || 0) + 1;
      this.controller?.abort(); this.observer?.disconnect(); this.controller = null;
    }
  }
  customElements.define('klove-fabric-picker', FabricPicker);
})();
